'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CaseSensitiveSanitizer = require('./CaseSensitiveSanitizer');

Object.defineProperty(exports, 'CaseSensitiveSanitizer', {
  enumerable: true,
  get: function get() {
    return _CaseSensitiveSanitizer.CaseSensitiveSanitizer;
  }
});

var _LowerCaseSanitizer = require('./LowerCaseSanitizer');

Object.defineProperty(exports, 'LowerCaseSanitizer', {
  enumerable: true,
  get: function get() {
    return _LowerCaseSanitizer.LowerCaseSanitizer;
  }
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/js-search/dist/commonjs/Sanitizer/index.js
// module id = 242
// module chunks = 1